<template>
  <div class="set_config_box">
    <div class="topOperation">
      <div class="top-left">
        <div><ShowNavHead/></div>
        <div class="screenInputs">
          <div class="screenInput">
            <div class="flname">姓名</div>
            <el-input size="small" clearable v-model="listQuery.Username" @keyup.enter.native="searchHandle"></el-input>
          </div>
          <div class="screenInput">
            <div class="flname">城市</div>
            <el-input size="small" clearable v-model="listQuery.strcity" @keyup.enter.native="searchHandle"></el-input>
            <el-button type="success" plain size="small" @click="searchHandle" style="margin-left:10px;">搜索</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>营销雷达</el-breadcrumb-item>
          <el-breadcrumb-item>管理</el-breadcrumb-item>
          <el-breadcrumb-item>区域配置</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="set_config_table">
        <comTabs ref="child" :active="activeName"></comTabs>
        <div class="sys_btns">
            <el-button type="primary" size="small" @click="addHandle">新增区域</el-button>
        </div>
        <el-table :data="tableData" :max-height="tableHeight-180" v-loading="listLoading">
          <el-table-column align="center" label="序号" width="80px">
            <template slot-scope="{$index}">
                <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
            </template>
          </el-table-column>
          <el-table-column label="姓名" align="center" prop="Username" min-width="100px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="区域" align="center" min-width="150px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.Strprovince == '全国'?'全国':row.Strprovince+' / '+row.Strcity}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作时间" align="center" min-width="130px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span>{{row.CreatedTime?row.CreatedTime.replace('T',' '):''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="有效期" align="center" min-width="200px" fit :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span v-if="row.Strperdatetype == '长期'">长期</span>
              <span v-else>{{row.DtstartDate?(row.DtstartDate.substring(0,10)+'至'+row.DtendDate.substring(0,10)):''}}</span>
            </template>
          </el-table-column>
          <el-table-column label="备注" align="center" prop="Remark" min-width="180px" fit :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="操作" align="center" fixed="right" min-width="160px">
            <template slot-scope="{row}">
              <el-button plain type="primary" size="mini" @click="editHandle(row)">编辑</el-button>
              <el-button v-if="row.IsDeleted == '1'" plain type="success" size="mini" @click="openHandle(row)">启用</el-button>
              <el-button v-if="row.IsDeleted == '0'" plain type="warning" size="mini" @click="closeHandle(row)">关闭</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination
            @current-change="handleCurrentChange"
            :current-page.sync="listQuery.currpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="listQuery.pagecount"
            layout="total,sizes,prev,pager,next,jumper"
            :total="totalcount"
          ></el-pagination>
        </div>
      </div>
    </div>

    <!-- 新增/修改弹框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
        <el-form :model="formQuery" ref="formData" :rules="formRule" label-width="96px" class="set_dialog_box">
          <el-form-item label="用户：" prop="roleuserid" class="form_item">
            <el-select v-model="formQuery.username" :disabled="isEdit" size="small" placeholder="" filterable @change="memChange">
              <el-option v-for="(item,index) in userList" :key="index" :label="item.Username" :value="item.Username"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="区域：" required class="form_item">
            <div class="area_box">
              <el-cascader :props="propsAddress" :disabled="checkedArea" size="small" filterable ref="cascaderArr" clearable placeholder="" v-model="formQuery.selectedArr" :options="areaList" @change="changeAreaHandle"></el-cascader>
              <el-checkbox-group v-model="checkAreaList" :max="1" @change="checkHandle" style="margin-left:5px;">
                <el-checkbox label="慈溪市"></el-checkbox>
                <el-checkbox label="全国"></el-checkbox>
              </el-checkbox-group>
            </div>
          </el-form-item>
          <el-form-item label="有效期：" required class="date_box">
            <el-row>
              <el-col :span="9">
                <el-form-item prop="DtstartDate">
                  <el-date-picker size="small" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :disabled="checkedLifespan"
                  v-model="formQuery.DtstartDate" type="date" @input="startDateChange"
                  placeholder="开始日期"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="1" style="text-align: center;">-</el-col>
              <el-col :span="9">
                <el-form-item prop="DtendDate">
                  <el-date-picker size="small" value-format="yyyy-MM-dd" format="yyyy-MM-dd" :disabled="checkedLifespan"
                  v-model="formQuery.DtendDate" type="date" @input="endDateChange"
                  placeholder="结束日期"></el-date-picker>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-checkbox v-model="checkedLifespan" style="margin-left:5px;">长期</el-checkbox>
              </el-col>
            </el-row>
          </el-form-item>
          <el-form-item label="数据管理员：" class="form_item">
            <el-radio v-model="formQuery.IsdataAdmin" label="1">是</el-radio>
            <el-radio v-model="formQuery.IsdataAdmin" label="0">否</el-radio>
          </el-form-item>
          <el-form-item label="备注：" class="form_item">
            <el-input v-model="formQuery.strremark" rows="3" type="textarea" clearable></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-button size="small" @click="dialogVisible=false">取消</el-button>
            <el-button size="small" type="primary" @click="confirmEdit">确定</el-button>
        </span>
    </el-dialog>
  </div>
</template>

<script>
import xz from "@/common";
import moment from 'moment';
import comTabs from './components/comTab.vue'
export default {
  components:{
    comTabs
  },
  data() {
    return {
        tablePath: this.$store.state.EMP.tablePath,
        tableHeight:0,
        activeName:'区域配置',
        dialogTitle:'新增区域',
        listLoading:false,
        listQuery:{
          currpage: 1,
          perpage: 10,
          Username:'',
          strcity:'' //区域
        },
        totalcount: 0,
        dialogVisible: false,
        // 有效期 长期
        checkedLifespan:false,
        formQuery: {
          GId:'',
          username: '',//姓名
          roleuserid:'',//员工id
          strremark:'',//备注
          strprovince:'',//省份
          strcity:'',//城市
          selectedArr:[],
          DtstartDate:'',//有效开始日期
          DtendDate:'',//有效结束日期
          Strperdatetype:'',//长期 短期
          IsDeleted: 0 ,//是否删除/启用 0 启用 1关闭
          IsdataAdmin:'0'
        },
        formRule:{
          roleuserid: [{
            required: true,
            message: "请选择人员",
            trigger: "change"
          }],
          // DtstartDate: [{
          //   required: true,
          //   message: "请选择开始日期",
          //   trigger: ['change']
          // }],
          // DtendDate: [{
          //   required: true,
          //   message: "请选择结束日期",
          //   trigger: ['change']
          // }],
          // selectedArr: [{ type: 'array', required: true, message: '请选择所属区域', trigger: 'change'}]
        },
        userList:[],
        tableData: [],
        checkedArea: false,
        checkAreaList:[],
        // 按钮权限参数
        butQuery:{
          roletype:'',
          page:'customList'
        },
        //角色类型
        roleType: '',
        isEdit:false,
        areaList:[],
        propsAddress:{label: 'Name', value: 'Name', children: 'children'}
    }
  },
  created() {
    this.roleType = localStorage.loginRoletype
    this.butQuery.roletype = localStorage.loginRoletype
    this.calHeight()
    this.getList()
    this.getprovinces()
    this.getUserList()
  },
  methods: {
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
    //   console.log('height',this.tableHeight)
    },
    // 新增区域人员
    addHandle(){
      this.formQuery = {
        GId:'',
        username: '',//姓名
        roleuserid:'',//员工id
        strremark:'',//备注
        strprovince:'',//省份
        strcity:'',//城市
        selectedArr:[],
        IsDeleted: 0,
        IsdataAdmin:'0',//是否是数据管理员
      }
      let that = this
      this.dialogVisible = true
      this.isEdit = false
      this.checkedArea = false
      
      this.checkAreaList = []
      // that.$refs['formData'].resetFields();
    },
    // 编辑区域人员
    editHandle(item){
      // console.log('dd',item)
      this.isEdit = true
      // 回显选中区域
      let proval,cityval;
      if(item.Strprovince != '全国'&&item.Strcity != '慈溪'){
        if(item.Strprovince.indexOf('自治区')>-1){
          proval = item.Strprovince
        }else{
          proval = item.Strprovince+'省'
        }
        if(item.Strcity.indexOf('盟')>-1||item.Strcity.indexOf('自治州')>-1||item.Strcity.indexOf('地区')>-1){
          cityval = item.Strcity
        }else{
          cityval = item.Strcity+'市'
        }
      }
      if(item.Strprovince == '全国'){
        proval = '全国'
        cityval = ''
      }
      this.formQuery = {
        GId: this.isNull(item.Id)?'':item.Id,
        username: item.Username,
        roleuserid: item.Userid,
        strremark: item.Remark,
        strprovince: item.Strprovince,
        strcity: item.Strcity,
        selectedArr: [proval,cityval],
        DtstartDate:item.DtstartDate,//有效开始日期
        DtendDate:item.DtendDate,//有效结束日期
        Strperdatetype:item.Strperdatetype,//长期 短期
        IsDeleted: item.IsDeleted,
        IsdataAdmin:item.IsdataAdmin ? item.IsdataAdmin : '0'
      }
      if(this.formQuery.strprovince == '全国'){
        this.checkedArea = true
        this.checkAreaList = ['全国']
      }else if(this.formQuery.strcity.indexOf('慈溪')>-1){
        this.checkedArea = true
        this.checkAreaList = ['慈溪市']
      }else{
        this.checkedArea = false
      }
      this.dialogVisible = true;
    },
    // 启用
    openHandle(item){
      let that = this
      this.formQuery = {
        GId: this.isNull(item.Id)?'':item.Id,
        username: item.Username,
        roleuserid: item.Userid,
        strremark: item.Remark,
        strprovince: item.Strprovince,
        strcity: item.Strcity,
        selectedArr: [item.Strprovince,item.Strcity],
        IsDeleted: 0,
        IsdataAdmin:item.IsdataAdmin ? item.IsdataAdmin : '0'
      }
      this.$confirm('是否确定启用?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        that.updateState()
      })
    },
    // 关闭
    closeHandle(item){
      let that = this
      this.formQuery = {
        GId: this.isNull(item.Id)?'':item.Id,
        username: item.Username,
        roleuserid: item.Userid,
        strremark: item.Remark,
        strprovince: item.Strprovince,
        strcity: item.Strcity,
        selectedArr: [item.Strprovince,item.Strcity],
        IsDeleted: 1
      }
      this.$confirm('是否确定关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((res) => {
        that.updateState()
      })
    },
    // 保存修改区域状态
    updateState(){
      xz.saverolearea(this.formQuery).then(res => {
        // console.log('saveEnterHandle', res)
        if (res.status == 'ok') {
          this.getList()
          this.$message({ type: 'success', message: '操作成功' })
        }else{
          this.$message({ type: 'error', message: '操作失败，请稍后再试' })
        }
      })
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1
      this.getList()
    },
    // 选择人员
    memChange(val){
      // console.log('ddd', val)
      let obj = {};
      let that = this
      if(!this.isNull(val)){
        obj = that.userList.find((item)=>{
            return item.Username === val;
        });
        that.formQuery.roleuserid = obj.Userid
      }else{
        that.formQuery.roleuserid = ''
      }
    },
    // 选择特殊区域
    checkHandle(val){
      // console.log('ddd', val)
      if(this.isNull(val)){
        this.checkedArea = false
      }else{
        this.checkedArea = true
        let city = val[0]
        if(city == '全国'){
          this.formQuery.strprovince = '全国'
          this.formQuery.strcity = '全国'
          this.formQuery.selectedArr = ['全国']
        }
        if(city == '慈溪市'){
          this.formQuery.strprovince = '浙江省'
          this.formQuery.strcity = '慈溪市'
          this.formQuery.selectedArr = ['浙江省','慈溪市']
        }
      }
    },
    //选择地址
    changeAreaHandle(val) {
      // console.log('ddd', val)
      if(!this.isNull(val)){
          // const checkedNode =  this.$refs["cascaderArr"].getCheckedNodes();
          // let labels = checkedNode[0].pathLabels
          if(val.length == 2 || val.length > 1){
            this.formQuery.strprovince = val[0]
            this.formQuery.strcity = val[1]
          }
          if(val.length == 1){
            this.formQuery.strprovince = val[0]
            this.formQuery.strcity = val[0]
          }
      }else{
        this.formQuery.strprovince = ''
        this.formQuery.strcity = ''
      }
    },
    //获取省市区
    getprovinces() {
      let that = this
      xz.getAreaAll().then(res => {
        // console.log('getprovinces', res)
        this.areaList = res;
        if(!this.isNull(this.areaList)){
          for (let key in this.areaList) {
            // 删除第三层children属性
            for (let i in that.areaList[key].children) {
               delete this.areaList[key].children[i].children
              // let other = that.areaList[key].children[i]
              // if(other.Name != '宁波市'){//不是宁波市删掉最后一级
              //   delete that.areaList[key].children[i].children
              // }else{//宁波市只留慈溪市
              //   for (let j in other.children) {
              //     let element = other.children[j];
              //     if(element.Name != '慈溪市'){
              //       delete other.children[j]
              //     }
              //   }
              // }
            }
          }
        }
      })
    },
    //取所有用户列表
    getUserList() {
        let data = {
            currpage: 1,
            perpage: 10000,
            keyword: '',
            strWorkState: '',
            strstation: '',
            strorgancode: ''
        }
        xz.getauthUserInfoByorgancode(data).then(res => {
            if (res.status == 'ok') {
                this.userList = res.msg;
            } else {
                this.userList = [];
            }
        })
    },
    getList(){
      this.listLoading = true
      xz.getroleareaList(this.listQuery).then(res =>{
        if(res.status == 'ok'){
          this.tableData = res.msg;
          this.totalcount = parseInt(res.totalcount);
        }else{
          this.tableData = [];
          this.totalcount = 0;
        }
        this.listLoading = false
      })
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`);
      this.listQuery.currpage = Number(val);
      this.getList();
    },
    handleSizeChange(val) {
        this.listQuery.perpage = Number(val);
        this.getList();
    },
    startDateChange(val){
      // console.log('33',val)
      this.formQuery.DtstartDate = val
      // 强制刷新视图
      this.$forceUpdate();
    },
    endDateChange(val){
      // console.log('33',val)
      this.formQuery.DtendDate = val
      // 强制刷新视图
      this.$forceUpdate();
    },
    //确认修改
    confirmEdit(){
      let that = this
      if(that.checkedLifespan == true){
        that.formQuery.DtstartDate = '1900-01-01'
        that.formQuery.DtendDate = '1900-01-01'
        that.formQuery.Strperdatetype = '长期'
      }else{
        that.formQuery.Strperdatetype = '短期'
      }
      if(that.isNull(that.formQuery.selectedArr)){
        this.$message({ type: 'warning', message: '请选择区域' })
        return false
      }
      if(that.isNull(that.formQuery.DtstartDate)){
        this.$message({ type: 'warning', message: '请选择有效期' })
        return false
      }
      if(that.isNull(that.formQuery.DtendDate)){
        this.$message({ type: 'warning', message: '请选择有效期' })
        return false
      }
      this.$refs['formData'].validate((valid) => {
        if (valid) {
            that.formQuery.strprovince = that.formQuery.strprovince.replace('省', '');
            that.formQuery.strcity = that.formQuery.strcity.replace('市', '');
            if(new Date(that.formQuery.DtstartDate).getTime() > new Date(that.formQuery.DtendDate).getTime()){
              this.$message({ type: 'warning', message: '开始日期不能大于结束日期' })
              return false
            }
            // console.log('saveEnterHandle', this.formQuery)
            xz.saverolearea(this.formQuery).then(res => {
              if (res.status == 'ok') {
                this.dialogVisible = false
                this.getList()
                this.$message({ type: 'success', message: '操作成功' })
              }else{
                this.$message({ type: 'error', message: '操作失败，请稍后再试' })
              }
            })
        } else {
            console.log('error submit!!');
            return false;
        }
      });
    },
    //判断是否为空(包含0)或1970
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [];
    },
    isDateNull(o) {
        return o == '1900-01-01' || (o + '').indexOf("1900-01-01") > -1;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.area_box{
  display: flex;
  align-items: center;
}
.sys_btns{
  display: flex;
  justify-content: flex-end;
  background-color: #fff;
  padding: 10px 10px 0;
}
.p_roster_table.el-tabs{
  background-color: #fff;
}
</style>

<style>
.set_dialog_box .el-date-editor.el-input{
  width: auto;
}
.set_config_box .screenInput .el-input{
  width: 200px;
}
.set_config_box .screenInput{
  margin: 0 0 10px 0;
}
.set_dialog_box .form_item .el-select,
.set_dialog_box .form_item .el-form-item__content{
  width: 440px;
}
.set_dialog_box .form_item .el-cascader{
  width: 280px;
}
.set_config_box .el-table .el-table__cell{
  padding: 5px 0;
}
</style>